import React from 'react';

function HospitalCubicalCurtains() {
  return (
    <>
      <style>{`
        .cont {
          min-height: 100vh;
          margin: 3rem;
        }

        .cntnt {
          display: flex;
          justify-content: space-around;
          align-items: center;
          flex-direction: column;
          padding: 2rem;
          background-color: #f0f0f0;
          border-radius: 10px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          width: 80%;
          margin: auto;
        }

        .para {
          margin-top: 2rem;
          text-align: center;
          font-size: 1.2rem;
          color: #333;
          padding: 0 2rem;
          line-height: 1.6;
          margin-bottom: 2rem;
        }

        .cntnt2 {
          display: flex;
        justify-content: left;
        align-items: center;
        flex-direction: row;
        
        width: 100%;
        margin: auto;
        margin-bottom: 2rem;
        }

        .cntnt2 img {
          margin-right: 2rem;
          width: 100%;
          max-width: 300px;
          height: auto;
          border-radius: 10px;
        }

        .para2 {
          margin-bottom: 2rem;
          padding: 0 1rem;
        }

        .img-sec {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
          padding: 2rem;
        }

        .img-sec div {
          width: 14%;
          min-width: 120px;
          margin: 1rem;
        }

        .img-sec img {
          width: 100%;
          height: 12rem;
          object-fit: cover;
          border-radius: 10px;
        }

        .img-sec p {
          text-align: center;
          font-size: 1rem;
          margin-top: 0.5rem;
        }

        /* ==================== Responsive Styles ==================== */
        @media (max-width: 1024px) {
          .cntnt {
            width: 90%;
            padding: 1.5rem;
          }

          .para {
            font-size: 1.1rem;
            padding: 0 1rem;
          }

          .img-sec div {
            width: 20%;
          }
        }

        @media (max-width: 768px) {
          .cntnt2 {
            flex-direction: column;
            align-items: center;
            text-align: center;
          }

          .cntnt2 img {
            margin: 0 auto;
          }

          .img-sec div {
            width: 40%;
          }

          .para {
            font-size: 1rem;
          }

          .img-sec p {
            font-size: 0.95rem;
          }
        }

        @media (max-width: 480px) {
          .cont {
            margin: 1.5rem;
          }

          .cntnt {
            width: 95%;
            padding: 1rem;
          }

          .img-sec div {
            width: 80%;
          }

          .para, .para2 {
            padding: 0 0.5rem;
            font-size: 0.95rem;
          }

          .img-sec img {
            height: auto;
          }
        }
      `}</style>

      <div className="cont">
        <div className="cntnt">
          <img src="image.png" alt="product" />
          <p>HOSPITAL CUBICAL CURTAINS</p>
        </div>

        <div className="para">
          <p>
            Curtains has been providing high class services in the health care
            industry and hotels for more than a decade. Today we have an
            incredibly excellent record of selling and installing cubical
            hospital & shower curtains.
          </p>
        </div>

        <div className="cntnt2">
          <img src="hcc1.png" alt="product" />
          <div>
            <h3>Cubical Tracks "Zx"</h3>
            <p>
              Made of aluminium box size 20.20 x 27.20 mm with 60 microns plus
              thick pure polyster powder coating finish with white color.
              Tracks can be shaped according to requirement or radius of 90
              degree angle to cover a bed.
            </p>
            <h3>Ceiling supporting system and other parts. Wall Bracket</h3>
            <p>Made of CRC steel with powder coating finish.</p>
          </div>
        </div>

        <div className="para2">
          <h3>Bridge clamp/Connector :</h3>
          <p>Made of aluminium with powder coating finish</p>

          <h3>Roof Suspension Hanger.</h3>
          <p>
            Made of aluminium pipe of 12.30 & 20.00 mm diameter. The Round
            plate of the suspension hanger is 44.27mm diameter with white
            powder coating finish and can be adjustable according to the height.
          </p>

          <h3>Runner Loading Point.</h3>
          <p>
            Made of SS for loading & uploading of runners without using any tool
            & also stop curtains to go beyond their width.
          </p>

          <h3>Runner</h3>
          <p>
            Made of delrin with two wheels & specially greased with silicon
            spray for smooth movement of curtain.
          </p>
        </div>

        <div className="cntnt2">
          <img src="hcc2.png" alt="product" />
          <div>
            <p>
              <b>Curtains :</b> 100% polyester fabrics premium quality made on
              shuttle looms with water repellent treatment 16"/24" nett on top.
              Curtains joints are finished with two way stitching rather than
              overlock.
            </p>

            <p>
              <b>Stain Resistant Curtains:</b> Resists penetration of liquid
              stains while allowing passage of moisture.
            </p>

            <p>
              <b>Anti Microbial Curtain:</b> Reduces/stops microbial growth.
            </p>

            <p>
              <b>Fire Retardant Curtain:</b> Reduces flammability & delays
              combustion.
            </p>
          </div>
        </div>

        <section className="img-sec">
          <div>
            <img src="hcc3.png" alt="product" />
            <p>Blackout Curtains</p>
          </div>
          <div>
            <img src="hcc4.png" alt="product" />
            <p>Shower Curtains</p>
          </div>
          <div>
            <img src="hcc5.png" alt="product" />
            <p>Cubical</p>
          </div>
          <div>
            <img src="hcc6.png" alt="product" />
            <p>Track</p>
          </div>
          <div>
            <img src="hcc7.png" alt="product" />
            <p>I.V. Hanger</p>
          </div>
        </section>
      </div>
    </>
  );
}

export default HospitalCubicalCurtains;
